import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'
import { normalizeWeightUnit } from '~/services/api/contracts/normalizeWeightUnit'
import { MenuItemPriceTypeSchema, MenuItemStatusSchema } from '~/services/api/generated'

export const menuItemFieldsNormalizer = fieldNormalizer({
  trimmed: ['name'],
  blankToNull: ['description', 'serves_count'],
  enums: [
    { field: 'status', options: MenuItemStatusSchema.options },
    { field: 'price_type', options: MenuItemPriceTypeSchema.options }
  ],
  custom: [{ keys: ['weight_unit'], apply: normalizeWeightUnit, skipNull: true }]
})
